import moment from 'moment';

export const formatDate = (date: string, format = 'DD-MM-YYYY') => {
  if (date === null || date === undefined) {
    return ' - ';
  }
  const momentDate = moment(date.replace('Z', ''));

  if (!momentDate.isValid()) {
    return ' - ';
  }
  return momentDate.format(format);
};

export const getMaxDeliveryDate = (): Date => moment().add(2, 'years').toDate();

export const isDateBeyondMaxDelivery = (date: string | Date): boolean =>
  moment(date).isAfter(moment().add(2, 'years'));
